module.exports = __webpack_public_path__ + "media/images/menu/hydra-a3587f86f7d7ced33e666d33bad2c706.jpg";